import { Button, Heading, Icon, Shadow, Text, HStack, Stack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React, { useCallback, useMemo } from 'react';

import { LateralBar } from '../../../../../../../../../../../../components/LateralBar';
import { PrivatePensionEntityNormalized } from '../../../../../../../../../../../../store/product/types';
import { PrivatePensionAssetController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PrivatePension';

import { BeneficiaryItem } from './components/BeneficiaryItem';

export namespace BeneficiariesCardTypes {
  export interface Props {
    offerController: PrivatePensionAssetController;
    onEdit: (index: number) => void;
    onAdd: () => void;
    offer: PrivatePensionEntityNormalized;
  }
}

export const BeneficiariesCard: React.FC<BeneficiariesCardTypes.Props> = ({
  offerController,
  onEdit,
  onAdd,
}) => {
  const { beneficiaries, currentParticipationPercentage } = offerController;

  const handleRemoveBeneficiary = useCallback(
    (index: number) => {
      offerController.removeBeneficiary(index);
    },
    [offerController]
  );

  const beneficiaryList = useMemo(() => {
    return beneficiaries.map((beneficiary, index) => {
      return (
        <BeneficiaryItem
          key={beneficiary.name}
          index={index}
          beneficiary={beneficiary}
          onEdit={onEdit}
          onRemove={handleRemoveBeneficiary}
          offerController={offerController}
        />
      );
    });
  }, [beneficiaries, handleRemoveBeneficiary, offerController, onEdit]);

  return (
    <Shadow level={1} borderRadius="sm">
      <LateralBar barColor="product.previdencia" />
      <VStack padding="inset.sm" space="stack.xxs">
        <Heading size="h3" testId="beneficiaries">
          Beneficiários
        </Heading>
        {beneficiaries.length === 0 && (
          <Text>
            Não havendo indicação, os herdeiros legais serão considerados os beneficiários.
          </Text>
        )}
        {beneficiaryList}
        <Stack
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          width="100%">
          <Button
            leftIcon={<Icon name="Plus" size="sm" color="brand.tertiary.principal" />}
            alignSelf="flex-start"
            onPress={onAdd}
            variant="textLink">
            Incluir Beneficiário
          </Button>
          <HStack space="stack.nano" alignItems="center">
            <Text variant="semibold">A participação total deve ser de 100%</Text>
            <Text variant="semibold">% total: </Text>
            <Text
              color={currentParticipationPercentage === 100 ? undefined : 'feedback.error.default'}>
              {Utils.Mask.Percentage(currentParticipationPercentage)}
            </Text>
          </HStack>
        </Stack>
      </VStack>
    </Shadow>
  );
};
